<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">Product Images</span>
      <button
        mat-icon-button
        (click)="close()"
        aria-label="Close dialog"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="px-16 pt-8 pb-16">
    <div class="border border-radius-4 py-4 px-8 table-bdr">
      <table>
        <tr>
          <th>#</th>
          <th>Image URL</th>
          <th>Action</th>
        </tr>
        <tr *ngFor="let imageUrl of data.images; let i = index">
          <td>{{ i + 1 }}</td>
          <td class="image-url-cell">
            <a 
              [href]="imageUrl" 
              target="_blank" 
              rel="noopener noreferrer"
              [title]="imageUrl"
              class="image-url-link"
            >
              {{ getTruncatedUrl(imageUrl) }}
            </a>
          </td>
          <td>
            <button
              mat-button 
              color="primary"
              class="view-image-btn"
              (click)="downloadImage(imageUrl, i)"
            >
              <mat-icon>download</mat-icon>
              View
            </button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
